export const BCM_STYLE = {
  // Containere principale
  overlay: "fixed inset-0 z-[110] flex items-center justify-center p-4 bg-[#020617]/95 backdrop-blur-xl animate-in fade-in duration-500",
  modal: "w-full max-w-5xl bg-[#0F172A] border border-slate-800 rounded-[2rem] shadow-2xl overflow-hidden flex flex-col md:flex-row h-[700px]",

  // Sidebar Stânga (Calendar)
  sidebarLeft: "w-full md:w-80 p-8 border-r border-slate-800 bg-slate-900/30 flex flex-col",
  stepHeader: "flex items-center gap-3 mb-8",
  stepIconBlue: "p-2 bg-blue-500/10 rounded-lg text-blue-500",
  stepLabel: "text-[10px] font-black text-slate-500 uppercase tracking-widest leading-none mb-1",
  stepTitle: "text-sm font-black text-white uppercase italic",

  calendarNav: "flex items-center justify-between mb-4 px-2",
  calendarNavBtn: "p-1 hover:bg-slate-800 rounded text-slate-400",
  monthDisplay: "text-xs font-mono font-bold text-blue-400 uppercase tracking-tighter",
  calendarGrid: "grid grid-cols-7 gap-1 flex-1",
  weekdayLabel: "text-center text-[9px] font-bold text-slate-600 mb-2",
  dayButtonBase: "aspect-square text-[11px] font-mono rounded-xl transition-all flex items-center justify-center",
  dayButtonActive: "bg-blue-600 text-white font-bold shadow-[0_0_15px_rgba(37,99,235,0.4)] scale-110",
  dayButtonInactive: "text-slate-300 hover:bg-slate-800 hover:text-white",

  // Secțiunea Centrală (Timeline)
  mainContent: "flex-1 p-8 overflow-y-auto no-scrollbar bg-[#020617]/50 relative",
  timelineSection: "flex flex-col gap-4 mb-10",
  sectionActive: "opacity-100",
  sectionDisabled: "opacity-20 pointer-events-none grayscale transition-all duration-500",

  // Header Timeline
  clockGlow: "absolute inset-0 bg-orange-500/20 blur-xl rounded-full animate-pulse",
  clockIconBox: "relative p-2.5 bg-orange-500/10 border border-orange-500/20 rounded-xl text-[#f26c15]",
  timelineHeaderLabel: "text-[10px] font-black text-orange-500/60 uppercase tracking-[0.3em] leading-none mb-1.5",
  timelineHeaderTitle: "text-sm font-black text-white uppercase italic tracking-tight",
  utcTag: "text-orange-500 ml-2 font-mono",

  // Legendă
  timelineLegendBox: "flex items-center gap-4 bg-slate-900/40 w-fit px-4 py-2 rounded-xl border border-white/5 backdrop-blur-md",
  legendItems: [
    { color: "bg-amber-600/40 border border-amber-500/50", label: "În așteptare" },
    { color: "bg-slate-700", label: "Liber" },
    { color: "bg-orange-950/40 border border-orange-900/50", label: "Ocupat" },
    { color: "bg-red-950/40 border border-red-900/50", label: "Mentenanță" }
  ],
  legendText: "text-[9px] font-black text-slate-500 uppercase tracking-tighter",

  // Slot-uri - Stiluri per Stare
  rowDivider: "h-[1px] w-full bg-gradient-to-r from-orange-500/20 via-slate-800 to-transparent",
  slotsGrid: "grid grid-cols-4 md:grid-cols-8 gap-2",
  slotBase: "group relative flex flex-col items-center justify-center py-3 rounded-xl border transition-all duration-200",

  slotStates: {
      available: "bg-slate-800/40 border-slate-700/50 text-slate-300 hover:border-orange-500/50 hover:bg-orange-500/5 cursor-pointer",
      booked: "bg-orange-950/20 border-orange-900/30 text-orange-900 cursor-not-allowed opacity-60",
      pending: "bg-amber-950/30 border-amber-700/40 text-amber-600/80 cursor-not-allowed opacity-70",
      maintenance: "bg-red-950/20 border-red-900/30 text-red-900 cursor-not-allowed opacity-60",
      selected: "bg-[#f26c15] border-orange-400 text-white shadow-[0_0_20px_rgba(242,108,21,0.4)] z-10 scale-105 cursor-pointer",
      default: "bg-slate-900/40 border-slate-800 text-slate-600 hover:border-slate-700 hover:text-slate-400 cursor-pointer"
      },

  // Stiluri Text Slot
  slotTextActive: "text-white",
  slotTextInactive: "text-inherit",
  slotStatusLabel: "text-[7px] font-black uppercase tracking-tighter mt-1 opacity-60",
  slotStatusActive: "text-orange-100",
  slotStatusInactive: "",

  slotDot: "absolute top-1 right-1 w-1 h-1 rounded-full bg-slate-600 group-hover:bg-orange-500",
  slotPing: "absolute -top-1 -right-1",
  pingContainer: "relative flex h-3 w-3",
  pingAnimate: "animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75",
  pingInner: "relative inline-flex rounded-full h-3 w-3 bg-white shadow-sm",

  // Scop Misiune
  missionSection: "transition-all duration-500 pb-12",
  missionGrid: "grid grid-cols-2 md:grid-cols-3 gap-3", // Schimbat la 3 coloane
  missionBtnBase: "py-3 px-4 rounded-xl border text-[10px] font-mono font-bold transition-all text-left", // Text la stânga + padding orizontal
  missionBtnActive: "bg-purple-600 border-purple-400 text-white shadow-lg",
  missionBtnInactive: "bg-slate-900/50 border-slate-800 text-slate-400 hover:border-slate-600",

    // Stiluri pentru input-ul Custom "Altul"
  customPurposeContainer: "mt-4 animate-in slide-in-from-top-2 duration-300",
  customPurposeInput: "w-full bg-slate-900 border border-purple-500/30 rounded-xl px-4 py-3 text-xs font-mono text-white focus:outline-none focus:border-purple-500 transition-all",

    // Icon-uri și etichete sumar
  iconBoxPurple: "p-2 bg-purple-500/10 rounded-lg text-purple-500",
  summaryPurposeText: "text-purple-400 font-bold truncate max-w-[120px]",

  // Sidebar Dreapta (Sumar)
  sidebarRight: "w-full md:w-80 bg-slate-900 p-8 flex flex-col border-l border-slate-800 relative",
    closeBtn: "absolute top-4 right-4 text-slate-600 hover:text-white transition-colors",

    // Header Sumar
    unitLabel: "text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1",
    unitReg: "text-lg font-black text-white font-mono tracking-tighter italic uppercase",

    // Card Detalii (Negru)
    detailsCard: "space-y-4 bg-black/40 p-5 rounded-2xl border border-white/5 font-mono",
    detailRow: "flex justify-between items-center text-[11px]",
    detailLabel: "text-slate-500 font-bold uppercase",
    detailValueDefault: "text-white",
    detailValueTime: "text-orange-500 font-bold", // Ora estimată
    detailValuePurpose: "text-purple-400 font-bold truncate max-w-[120px]", // Scop misiune

    // Border-uri între rânduri
    rowBorderB: "border-b border-white/5 pb-3",
    rowBorderT: "border-t border-white/5 pt-3",

    // Card Cost (Albastru)
    costCard: "bg-blue-600/10 p-5 rounded-2xl border border-blue-500/20",
    costLabel: "text-[9px] text-blue-400 font-black uppercase mb-1",
    priceValue: "text-3xl font-black text-white italic",
    currencyLabel: "text-[10px] text-slate-600 font-bold",

    // Buton Acțiune Finală
    confirmBtnBase: "w-full py-5 rounded-2xl font-black uppercase text-xs tracking-[0.2em] transition-all flex items-center justify-center gap-3 active:scale-95",
    confirmBtnActive: "bg-[#f26c15] text-white shadow-lg hover:brightness-110",
    confirmBtnDisabled: "bg-slate-800 text-slate-600 cursor-not-allowed opacity-50",

    overlay2: "fixed inset-0 w-screen h-screen z-[9999] flex items-center justify-center p-0 md:p-4 bg-[#020617]/50 backdrop-blur-xl animate-in fade-in duration-500",
    modal2: "w-full h-full md:h-[700px] md:max-w-5xl bg-[#0F172A] border border-slate-800 rounded-[2rem] md:rounded-[2rem] shadow-2xl overflow-hidden flex flex-col md:flex-row",
};
